import { useDetailApi } from "../../../swr/useApi";
import { partnersService } from "../../api_client";
import type { PartnerChildDto } from "../../../api";

export function usePartnerChildren(partnerId: number) {
  return useDetailApi<PartnerChildDto[]>({
    key: partnerId ? `partner-children-${partnerId}` : null,
    serviceMethod: async () => await partnersService.getPartnerChildren(partnerId),
  });
}
